/* Base */

.eds-radio {
  --eds--color--border-input-default: var(--eds--palette-gray-500);
  --eds--color--border-input-strong: var(--eds--palette-gray-700);
  width: 100%;
}

.eds-radio--control {
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  height: var(--eds--size-20);
  isolation: isolate;
  justify-content: center;
  padding: var(--eds--padding-2);
  position: relative;
  width: var(--eds--size-20);
}

.eds-radio--input {
  cursor: inherit;
  height: 100%;
  inset: 0;
  margin: 0;
  opacity: 0;
  position: absolute;
  width: 100%;
  z-index: var(--eds--z-index-2);
}

.eds-radio--indicator {
  background: var(--eds--color--bg-base);
  border: var(--eds--size-1) solid var(--eds--color--border-input-default);
  border-radius: var(--eds--radii-full);
  box-sizing: border-box;
  height: var(--eds--size-16);
  position: relative;
  width: var(--eds--size-16);
  z-index: var(--eds--z-index-raised);
}

/*
 * Only the control and the label activate the input, so the pointer lives on
 * those two elements rather than the row — the gap and the hint below the label
 * select nothing. The label hugs its text so the hit area stops where the words
 * do instead of running the width of the row.
 */
.eds-radio--label {
  align-self: flex-start;
  cursor: pointer;
}

/* States */

.eds-radio--disabled {
  opacity: var(--eds--opacity-disabled);
}

.eds-radio--disabled .eds-radio--control,
.eds-radio--disabled .eds-radio--label {
  cursor: not-allowed;
}

.eds-radio--control::before {
  background-color: var(--eds--color--bg-base);
  background-image: linear-gradient(
    var(--eds--overlay-hover-default),
    var(--eds--overlay-hover-default)
  );
  border-radius: var(--eds--radii-full);
  content: '';
  height: var(--eds--size-24);
  left: 50%;
  opacity: 0;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: var(--eds--size-24);
  z-index: var(--eds--z-index-base);
}

.eds-radio--control:has(.eds-radio--input:hover:not(:disabled)):not(
  :has(.eds-radio--input:focus-visible)
)::before {
  opacity: 1;
}

.eds-radio--input:hover:not(:disabled) + .eds-radio--indicator {
  border-color: var(--eds--color--border-input-strong);
}

.eds-radio--control::after {
  background: var(--eds--color--bg-base);
  border: var(--eds--size-2) solid var(--eds--color--border-brand);
  border-radius: var(--eds--radii-full);
  box-sizing: border-box;
  content: '';
  height: var(--eds--size-24);
  left: 50%;
  opacity: 0;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: var(--eds--size-24);
  z-index: var(--eds--z-index-base);
}

.eds-radio--control:has(.eds-radio--input:focus-visible:not(:disabled))::after {
  opacity: 1;
}

.eds-radio--indicator-selected {
  background: var(--eds--color--bg-brand-strong);
  border-color: var(--eds--color--bg-brand-strong);
}

.eds-radio--indicator-selected::after {
  background: var(--eds--color--bg-base);
  border-radius: var(--eds--radii-full);
  content: '';
  height: var(--eds--size-4);
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: var(--eds--size-4);
}
